<template lang="pug">
  .booking-form(:class="{'dock-select-boxes': isCostCalculatorAvailable}")

    .container
      .booking-form__wrapper
        SelectBoxDateRange.booking-form__select-box(
          title="Когда"
          placeholder="Выберите период"
          @clear="clearDate"
        )

        SelectBox.booking-form__select-box(
          :class="{'select-box--sticky': isAddressSelectBoxSticky}"
          :disabled="!isAddressSelectBoxAvailable"
          title="Адрес"
          :value="currentAddress && currentAddress.formatted_address"
          placeholder="Выберите адрес"
          route="/address"
          @clear="clearAddress"
        )

        SelectBox.booking-form__select-box(
          :disabled="!isItemSelectBoxAvailable"
          title="Услуга"
          :value="currentItem && currentItem.title"
          placeholder="Выберите услугу"
          route="/item"
          @clear="clearItem"
        )

        SelectBox.booking-form__select-box(
          :disabled="!isVariationsSelectBoxAvailable"
          title="Вариант услуги"
          :value="currentVariation && currentVariation.desc"
          placeholder="Выберите вариант"
          route="/variation"
          @clear="clearVariation"
        )

        SelectBox.booking-form__select-box(
          :disabled="!isPersonSelectBoxAvailable"
          :title="personAppeal"
          :show-avatar="true"
          :avatar-url="currentPerson && currentPerson.img"
          :value="currentPerson && currentPerson.name"
          placeholder="Выберите персонал"
          route="/person"
          @clear="clearPerson"
        )

        SelectBox.booking-form__select-box(
          :disabled="!isEventSelectBoxAvailable"
          title="Дата и время"
          :value="eventsDatetimeTitles"
          placeholder="Выберите дату и время"
          route="/event"
          @clear="clearEvents"
        )


    .container
      CostCalculator

    .container
      PaymentOption

    .container
      UserCheck

    .container
      UserComment

    .container
      SubmitButton

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SelectBox from "@/components/SelectBox.vue";
import SelectBoxDateRange from "@/components/SelectBoxDateRange";
import CostCalculator from "@/components/CostCalculator/CostCalculator";
import PaymentOption from "@/components/PaymentOption";
import UserCheck from "@/components/UserCheck";
import UserComment from "@/components/UserComment";
import SubmitButton from "@/components/SubmitButton";

export default {
  name: 'Home',
  components: {
    SelectBox,
    SelectBoxDateRange,
    CostCalculator,
    PaymentOption,
    UserCheck,
    UserComment,
    SubmitButton
  },
  data() {
    return {
      staticClassObject: {
        'dock-select-boxes': null,
      }
    }
  },
  computed: {
    ...mapGetters('date', {
      isDateValid: 'isValid',
      dateRange: 'getHumanReadableRange'
    }),
    ...mapGetters('address', {
      currentAddress: 'getCurrentAddress',
      isAddressExist: 'isAddressExist'
    }),
    ...mapGetters('item', {
      currentItem: 'getCurrentItem',
      isItemExist: 'isItemExist',
    }),
    ...mapGetters("variation", {
      currentVariation: 'getCurrentVariation',
    }),
    ...mapGetters("person", {
      currentPerson: "getCurrentPerson"
    }),
    ...mapGetters("event", {
      eventsDatetimeTitles: "getCurrentEventsDatetimeTitles",
      currentEvents: "getCurrentEvents"
    }),
    ...mapGetters('config', {personAppeal: 'getPersonAppeal'}),

    isAddressSelectBoxAvailable() {
      return this.isDateValid;
    },
    isItemSelectBoxAvailable() {
      return !!this.currentAddress;
    },
    isVariationsSelectBoxAvailable() {
      return !!this.currentItem;
    },
    isPersonSelectBoxAvailable() {
      return !!this.currentAddress;
    },
    isEventSelectBoxAvailable() {
      return !!this.currentVariation;
    },
    isCostCalculatorAvailable() {
      return !!this.currentEvents.length;
    },
    isAddressSelectBoxSticky(){
      return this.isAddressSelectBoxAvailable && !this.isItemSelectBoxAvailable;
    },
  },
  methods: {
    ...mapActions('date', ['clearDate']),
    ...mapActions('address', ['clearAddress']),
    ...mapActions('item', ['clearItem']),
    ...mapActions('variation', ['clearVariation']),
    ...mapActions('person', ['clearPerson']),
    ...mapActions('event', ['clearEvents']),
  },
};
</script>
